import { valueMapObject } from '@/components/PatientDataTable';
import { PaginationOptions } from '@/types';

export const VALUE_MAP: valueMapObject = {
	male: 'Male',
	female: 'Female',
	other: 'Other',
	unknown: 'Unknown',
	intersex: 'Intersex',
	70: 'Prospect',
	100: 'Candidate',
	500: 'Approved',
	510: 'Ready To Engage',
	520: 'Engaged',
	530: 'Consent Delegated',
	540: 'Consent Pending',
	550: 'Consented',
	560: 'Device Dispatched',
	580: 'Re-screening Required',
	600: 'Screened',
	602: 'StudySite Contacted',
	604: 'StudySite Scheduled',
	606: 'StudySite Screening',
	610: 'Randomised',
	650: 'Enrolled',
	800: 'Trained',
	900: 'Off Boarding',
	1000: 'Completed',
	call_back: 'Call back',
	unsuccessful: 'Unsuccessful',
	successful: 'Successful',
	phone_mobile: 'mobile phone number',
	phone_home: 'home phone number',
	email: 'Email',
	sms: 'SMS',
	home_phone_call: 'Home Phone Call',
	mobile_phone_call: 'Mobile Phone Call',
	follow_up: 'Follow Up',
	true: 'Yes',
	false: 'No',
	completed_with_assistance: 'Yes',
	completed_no_assistance: 'No',
};

export const KEY_MAP: valueMapObject = {
	date_of_birth_from: 'Born after',
	gender: 'Gender',
	legal_sex: 'Legal Sex',
	number_of_letters_sent: 'Contacted by letter',
	partnership: 'Partnership',
	provider: 'Provider',
	status: 'Status',
	tag: 'Tags',
	contact_booked_for: 'Call booked today',
	contact_before_date: 'Contacted before 5 days',
	outcome: 'Outcome',
	number_of_contact_attempts: 'Number of contact attempts',
	engaged_since: 'First engaged since',
	cohort_subgroup: 'Cohort',
	age: 'Age',
	before_date: 'To date',
	from_date: 'Date from',
	show_active: 'Show active',
	letters_count: 'Contacted by letter',
	max_results: 'Maximum number of patients',
	mailing_id: 'Mailing',
	template_id: 'Template',
	created_from: 'Date calls booked from',
	created_to: 'Date calls booked to',
	study_id: 'Study',
	survey_filters: 'Survey',
	criteria_include: 'Have tagged search criteria',
	criteria_exclude: 'Don’t have tagged search criteria',
	survey_to_date: 'Date to',
	survey_from_date: 'Date from',
	survey_needs_assistance: 'Survey completed with assistance',
	search: 'Search',
	contact_filters: 'Contact',
	contact_method: 'Contact Method',
	needs_assistance: 'Needs assistance',
	hci_id: 'HCI',
	person_lists_include: 'Include patient list',
	person_lists_exclude: 'Exclude patient list',
	patient_ids_include: 'Patient IDs Include',
	patient_ids_exclude: 'Patient IDs Exclude',
	opt_out_reason: 'Opt Out Reason',
};

export const PAGINATION_OPTIONS_DEFAULT: PaginationOptions[] = [
	{
		label: '10',
		value: '10',
	},
	{
		label: '20',
		value: '20',
	},
	{
		label: '50',
		value: '50',
	},
	{
		label: '100',
		value: '100',
	},
];

export const PAGINATION_OPTIONS_DEFAULT_FEW: PaginationOptions[] = [
	{
		label: '3',
		value: '3',
	},
	{
		label: '5',
		value: '5',
	},
	{
		label: '10',
		value: '10',
	},
];

export const outerElementsHeight = {
	// These are used to generate the optimum height of an empty data table so that it takes-up all remaining space on the page
	// Values should match the combined height of any elements we want to appear on screen outside of the data table.
	// Currently: header, breadcrumbs, data table heading, customise columns button, padding and borders.
	sm: 'min-h-[calc(100vh-375px)]',
	md: 'md:min-h-[calc(100vh-350px)]',
};

// identifier key for the details side panel
export const DETAILS_SIDE_PANEL = 'detailsSidePanel';
